import SignupStepper from './_steps';
import { useMsal } from '@azure/msal-react';
import { getLoginRequest } from 'auth';
import { defaultHomePage } from 'auth/msalReactAuthProvider';
import BasicLayout from 'kosmos/basicLayout';
import { GetLogoByOrganisationId } from 'services/smeUser';

export default function Signup({ organisationId }: { organisationId?: string }): JSX.Element {
  const { instance } = useMsal();

  const login = async () => {
    await instance.loginRedirect(getLoginRequest(defaultHomePage));
  };

  const brandingGetter = (orgId?: string) => {
    if (!orgId) {
      return undefined;
    }
    return async () => await GetLogoByOrganisationId(orgId);
  };

  return (
    <BasicLayout brandingGetter={brandingGetter(organisationId)}>
      <SignupStepper login={login} />
    </BasicLayout>
  );
}
